import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import React from 'react'
import { get, isEmpty } from 'lodash'
import { compose } from 'recompose'
import { Button, Col, Form, Input, Row } from 'antd'
import StatusSelect from '../../../elements/Select/Subsidiary/Status'
import CountrySelect from '../../../elements/Select/Country'
import { defaultFormItemLayout, rules } from '../../../modules/FormItems'

function SubsidiaryDetailsForm(props) {
  const { submitting, subsidiary, update } = props
  const { getFieldDecorator } = props.form

  const member = get(subsidiary, 'member._id', get(subsidiary, 'owner', '')).replace('members/', '')
  const [LenderContractSelect] = useFetchSelectUrl(
    {
      name: 'headerLines',
      url: `/lenders/contracts/${member}/`,
      forceFetch: true,
    },
    [member],
    isEmpty(member)
  )

  console.log({ subsidiary })
  return (
    <Form>
      <Row className="m-auto">
        <Col span={12}>
          <Form.Item label={'Base URL'} {...defaultFormItemLayout}>
            {getFieldDecorator('baseURL', {
              initialValue: get(subsidiary, 'baseURL'),
            })(<Input style={{ width: '100%' }} placeholder="Base URL" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Status'} {...defaultFormItemLayout}>
            {getFieldDecorator('status', {
              initialValue: get(subsidiary, 'status'),
              rules: rules.select,
            })(<StatusSelect placeholder="Status" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Location'} {...defaultFormItemLayout}>
            {getFieldDecorator('location', {
              initialValue: get(subsidiary, 'location'),
            })(<CountrySelect />)}
          </Form.Item>
        </Col>
        {/*<Col span={12}>
          <Form.Item label={'Registration Date'} {...defaultFormItemLayout}>
            <DatePicker
              style={{ width: '100%' }}
              placeholder="Registration Date"
              value={dateVal(subsidiary, 'date.registration')}
              disabled
            />
          </Form.Item>
        </Col>*/}
        <Col span={12}>
          <Form.Item label={'Tax Registration'} {...defaultFormItemLayout}>
            {getFieldDecorator('taxRegistration', {
              initialValue: get(subsidiary, 'taxRegistration'),
            })(<Input style={{ width: '100%' }} placeholder="Tax Registration" />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label={'Default Bank'} {...defaultFormItemLayout}>
            {getFieldDecorator('default.lenderContract', {
              initialValue: get(subsidiary, 'default.lenderContract'),
            })(<LenderContractSelect keyAtr={'_id'} valueAtr={'title'} />)}
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button loading={submitting} type="primary" onClick={update}>
          Update
        </Button>
      </Form.Item>
    </Form>
  )
}

export default compose(Form.create())(SubsidiaryDetailsForm)
